import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import PeriodicTypeApi from '../server/PeriodicTypeApi';


function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

export default {

    getAll: function () {
        const handleSuccess = createSuccessHandler(ActionTypes.PERIODIC_TYPE_LIST);
        const handleError = createErrorHandler(ActionTypes.PERIODIC_TYPE_LIST);

        return PeriodicTypeApi.getAll()
            .then(handleSuccess, handleError)
            .catch(handleError);
    }
}
